export default "__VITE_ASSET__gLQo3jYF__"